import request from '@/utils/request'

// 获取用户列表
export function getConfig(data) {
  return request({
    url: '/api/Index/config',
    method: 'get'
  })
}

// 添加用户
export function addUser(data) {
  return request({
    url: '/user/add',
    method: 'post',
    data
  })
}

// 查询订单是否支付
export const checkorderpay = (data) => {
    return request({
        url: '/api/wx_pay/query_order',
        method: 'post',
        data:{order_no:data}
    })
}


// 发送验证码
export function sendCode(data) {
  return request({
    url: '/api/Login/send_code',
    method: 'post',
    data:data
  })
}

// 手机号登录
export function phoneLogin(data) {
  return request({
    url: '/api/Login/telCode_login',
    method: 'post',
    data:data
  })
}

// 账号密码登录
export function codeLogin(data) {
  return request({
    url: '/api/Login/telPwd_login',
    method: 'post',
    data:data
  })
}

// 用户信息
export function userInfo (data) {
  return request({
    url: '/api/User',
    method: 'post',
    data:data
  })
}

// 成为商家
export function beShop (data) {
  return request({
    url: '/api/Shop/shop_apply',
    method: 'post',
    data:data
  })
}

// 单页管理
export function getRules (data) {
  return request({
    url: '/api/Index/page?id='+data,
    method: 'get'
  })
}

// 获取招聘信息
export function getpoInfo () {
  return request({
    url: '/api/Shop/add_job?source=3',
    method: 'get'
  })
}

// 发布招聘信息
export function publicZp (data) {
  return request({
    url: '/api/Shop/add_job',
    method: 'post',
    data:data
  })
}

// 获取活动分类
export function getActivityCate () {
  return request({
    url: '/api/Shop/add_activity?source=3',
    method: 'get'
  })
}

// 发布活动
export function pubActivity (data) {
  return request({
    url: '/api/Shop/add_activity',
    method: 'post',
    data:data
  })
}

// 活动列表
export function getAcList (data) {
  return request({
    url: '/api/Shop/activity_list',
    method: 'post',
    data:data
  })
}

// 活动详情回显
export function getAcDetail (data) {
  return request({
    url: '/api/Shop/add_activity?id='+data.id+'&source='+data.source,
    method: 'get'
  })
}

// 上架下架活动
export function updownAc (data) {
  return request({
    url: '/api/Shop/activity_del',
    method: 'post',
    data:data
  })
}

// 招聘列表
export function recriList (data) {
  return request({
    url: '/api/Shop/job_list',
    method: 'post',
    data:data
  })
}

// 招聘上下架 
export function updownRe (data) {
  return request({
    url: '/api/Shop/job_del',
    method: 'post',
    data:data
  })
}

// 招聘回显
export function recruBk (data) {
  return request({
    url: '/api/Shop/add_job?id='+data.id+"&source="+data.source,
    method: 'get'
  })
}

// 服务采购列表
export function getServiceList (data) {
  return request({
    url: '/api/Shop/fwcg_list',
    method: 'post',
    data:data
  })
}

// 服务采购回显
export function serviceBk (data) {
  return request({
    url: '/api/Shop/add_fwcg?id='+data.id+'&source='+data.source,
    method: 'get'
  })
}

// 发布服务采购
export function puService (data) {
  return request({
    url: '/api/Shop/add_fwcg',
    method: 'post',
    data:data
  })
}

// 采购服务上线下线
export function upService (data) {
  return request({
    url: '/api/Shop/fwcg_del',
    method: 'post',
    data:data
  })
}

// 企业信息回显
export function getCompany (data) {
  return request({
    url: '/api/Shop/index',
    method: 'post',
    data:data
  })
}

// 提交企业信息
export function subCompany (data) {
  return request({
    url: '/api/Shop/add_shop_info',
    method: 'post',
    data:data
  })
}


export function shopchangePhone (data) {
  return request({
    url: '/api/Shop/edit_tel',
    method: 'post',
    data:data
  })
}

// 修改密码 
export function shopchangePwd (data) {
  return request({
    url: '/api/Shop/edit_pwd',
    method: 'post',
    data:data
  })
}


// 获取投递的简历
export function getJl (data) {
  return request({
    url: '/api/Shop/job_resume',
    method: 'post',
    data:data
  })
}

// 获取报名人列表
export function signpeople (data) {
  return request({
    url: '/api/Shop/activity_checkUser',
    method: 'post',
    data:data
  })
}

// 查看报名人信息
export function checkpeople (data) {
  return request({
    url: '/api/Shop/activity_check_info',
    method: 'post',
    data:data
  })
}

// 审核通过/拒绝活动
export function shenAc (data) {
  return request({
    url: '/api/Shop/activity_check',
    method: 'post',
    data:data
  })
}  

// 微信授权登录
export function getWechat (data) {
  return request({
    url: '/api/Login/qrCode_login',
    method: 'post',
    data:data
  })
}

// 获取渠道列表
export function getChannelList (data) {
  return request({
    url: '/api/Shop/activity_channel',
    method: 'post',
    data:data
  })
}

// 添加渠道
export function addChannel (data) {
  return request({
    url: '/api/Shop/activity_channel_add',
    method: 'post',
    data:data
  })
}

// 删除渠道 
export function delChannel (data) {
  return request({
    url: '/api/Shop/activity_channel_del',
    method: 'post',
    data:data
  })
}

// 首页接口
export function getIndex (data) {
  return request({
    url: '/api',
    method: 'get'
  })
}

// 首页推荐
export function getRecommands () {
  return request({
    url: '/api/Index/pc_index',
    method: 'post'
  })
}

// 获取活动分类
export function getActivityCates () {
  return request({
    url: '/api/Activity',
    method: 'get'
  })
}

// 获取活动列表
export function getActiviesList (data) {
  return request({
    url: '/api/Activity/_list',
    method: 'post',
    data:data
  })
}

// 获取活动详情
export function getActivitiesDetails (data) {
  return request({
    url: '/api/Activity/detail?id='+data,
    method: 'get'
  })
}

// 获取直播列表
export function getLiveList (data) {
  return request({
    url: '/api/Live/_list',
    method: 'post',
    data:data
  })
}

// 职业认证列表
export function getZylist (data) {
  return request({
    url: '/api/Zhiye/_list',
    method: 'post',
    data:data
  })
}

// 学历提升列表
export function getEduList (data) {
  return request({
    url: '/api/Education/_list',
    method: 'post',
    data:data
  })
}

// 服务采购列表
export function getServiceLists (data) {
  return request({
    url: '/api/Fwcg/_list',
    method: 'post',
    data:data
  })
}

// 收藏活动
export function collectAcs (data) {
  return request({
    url: '/api/Activity/collect_activity',
    method: 'post',
    data:data
  })
}

// 关注企业
export function focusCom (data) {
  return request({
    url: '/api/Activity/shop_follow',
    method: 'post',
    data:data
  })
}

// 关注导师
export function focusTeacher (data) {
  return request({
    url: '/api/Mentor/follow_mentor',
    method: 'post',
    data:data
  })
}

// 活动下单页面
export function signpage (data) {
  return request({
    url: '/api/Activity/submit_order?activity_id='+data.activity_id+"&num="+data.num+"&spec_id="+data.spec_id,
    method: 'get'
  })
}

// 提交活动报名  
export function signAc (data) {
  return request({
    url: '/api/Activity/submit_order',
    method: 'post',
    data:data
  })
}


export const getRIndex = () => {
    return request({
        url: '/api/Job',
        method: 'get'
    })
}

// 获取用户报名信息
export const getSignInfo = (data) => {
    return request({
        url: '/api/User/add_activity_registration',
        method: 'get'
    })
}


// 获取招聘列表
export const getRelist = (data) => {
    return request({
        url: '/api/Job/_list',
        method: 'post',
        data:data
    })
}

// 直播首页
export const getLiveIndex = () => {
    return request({
        url: '/api/Live/index',
        method: 'get'
    })
}

// 直播详情
export const getLiveDetail = (data) => {
    return request({
        url: '/api/Live/detail?id='+data,
        method: 'get'
    })
}

// 获取导师页面轮播和分类
export const getCoachBanner = (data) => {
    return request({
        url: '/api/Mentor',
        method: 'get'
    })
}

// 获取导师列表
export const getCoachList = (data) => {
    return request({
        url: '/api/Mentor/_list',
        method: 'post',
        data:data
    })
}

// 获取导师详情
export const getCoachDetail = (data) => {
    return request({
        url: '/api/Mentor/detail?id='+data,
        method: 'get'
    })
}

// 职业认证分类
export const getcerCate = (data) => {
    return request({
        url: '/api/Zhiye',
        method: 'get'
    })
}

// 职业认证列表
export const getcerList = (data) => {
    return request({
        url: '/api/Zhiye/_list',
        method: 'post',
        data:data
    })
}

// 职业认证详情
export const getcerDetail = (data) => {
    return request({
        url: '/api/Zhiye/detail?id='+data,
        method: 'get'
    })
}

// 职业认证下单
export const subre = (data) => {
    return request({
        url: '/api/Zhiye/submit_order',
        method: 'post',
        data:data
    })
}

// 获取学历提升banner
export const getEduBanner = () => {
    return request({
        url: '/api/Education',
        method: 'get'
    })
}

// 学历提升详情
export const getEduDetail = (data) => {
    return request({
        url: '/api/Education/detail?id='+data,
        method: 'get'
    })
}

// 获取服务采购
export const getServiceBanner = (data) => {
    return request({
        url: '/api/Fwcg',
        method: 'get'
    })
}

// 获取服务采购
export const getServiceDetail = (data) => {
    return request({
        url: '/api/Fwcg/detail?id='+data,
        method: 'get'
    })
}

// 图书购买分类
export const getbooksCate = (data) => {
    return request({
        url: '/api/Book',
        method: 'get'
    })
}

// 获取图书列表
export const getBookList = (data) => {
    return request({
        url: '/api/Book/_list',
        method: 'post',
        data:data
    })
}

// 图书详情
export const getBookDetail = (data) => {
    return request({
        url: '/api/Book/detail?id='+data,
        method: 'get'
    })
}

// 添加用户地址
export const addAddress = (data) => {
    return request({
        url: '/api/Address/edit',
        method: 'post',
        data:data
    })
}

// 获取用户订单列表
export const getAddressList = () => {
    return request({
        url: '/api/Address',
        method: 'get'
    })
}

// 设置默认收货地址
export const setDefaultAdd = (data) => {
    return request({
        url: '/api/Address/address_default',
        method: 'post',
        data:data
    })
}

// 删除收货地址
export const delAdd = (data) => {
    return request({
        url: '/api/Address/del',
        method: 'post',
        data:data
    })
}

// 获取地址详情
export const getAdd = (data) => {
    return request({
        url: '/api/Address/edit?address_id='+data,
        method: 'get'
    })
}

// 图书下单
export const confirmBookOrder = (data) => {
    return request({
        url: '/api/Book/submit_order',
        method: 'post',
        data:data
    })
}

// 求职招聘获取轮播
export const getRecruIndex = (data) => {
    return request({
        url: '/api/Job',
        method: 'get'
    })
}

// 获取求职招聘列表
export const getRecruList = (data) => {
    return request({
        url: '/api/Job/_list',
        method: 'post',
        data:data
    })
}

// 获取招聘详情
export const getRecruDetail = (data) => {
    return request({
        url: '/api/Job/detail?id='+data,
        method: 'get'
    })
}

// 获取企业信息
export const getCompanyInfo = (data) => {
    return request({
        url: '/api/Job/shop_info',
        method: 'post',
        data:data
    })
}

// 获取图书订单
export const getBookOrder = (data) => {
    return request({
        url: '/api/Book/order_list',
        method: 'post',
        data:data
    })
}

// 获取用户关注列表
export const getFocusList = (data) => {
    return request({
        url: '/api/User/follow_list',
        method: 'post',
        data:{'type':data}
    })
}

// 获取职业认证订单列表
export const getcList = (data) => {
    return request({
        url: '/api/Zhiye/order_list',
        method: 'post',
        data:data
    })
} 

// 获取活动订单列表
export const getaList = (data) => {
    return request({
        url: '/api/Activity/order_list',
        method: 'post',
        data:data
    })
}

// // 系统消息列表 
// export const getMessagelistItem = (data) => {
//     return request({
//         url: '/api/Index/system_notice?page='+data.page+'&size=20',
//         method: 'get'
//     })
// }

// 获取图书订单详情 
export const getBookOrderDetail = (data) => {
    return request({
        url: '/api/Book/order_detail',
        method: 'post',
        data:data
    })
}

// 我的收藏
export const myCollection = (data) => {
    return request({
        url: '/api/User/collect_list',
        method: 'post',
        data:{'type':data}
    })
}

// 收藏图书
export const collectbook = (data) => {
    return request({
        url: '/api/Book/collect_book',
        method: 'post',
        data:{'id':data}
    })
}

// 收藏活动
export const collectac = (data) => {
    return request({
        url: '/api/Activity/collect_activity',
        method: 'post',
        data:{'id':data}
    })
}

// 收藏活动
export const collectlive = (data) => {
    return request({
        url: '/api/Live/collect_live',
        method: 'post',
        data:{'id':data}
    })
}

// 收藏职位
export const collecthr = (data) => {
    return request({
        url: '/api/Job/collect_job',
        method: 'post',
        data:{'id':data}
    })
}

// 活动订单详情
export const acorderdetail = (data) => {
    return request({
        url: '/api/Activity/order_detail',
        method: 'post',
        data:{'order_id':data}
    })
}

// 修改用户信息
export const edituser = (data) => {
    return request({
        url: '/api/User/edit_user',
        method: 'post',
        data:data
    })
}

// 修改用户信息
export const shopedituser = (data) => {
    return request({
        url: '/api/Shop/edit_user',
        method: 'post',
        data:data
    })
}

// 系统消息列表 
export const getMessagelistItem = (data) => {
    return request({
        url: '/api/Index/system_notice?page='+data.page+'&size=20&is_type=2',
        method: 'get'
    })
}

// 商家端系统详情 
export const getMessageDetail = (data) => {
    return request({
        url: '/api/Shop/system_notice_detail?id='+data,
        method: 'get'
    })
}

// 发送简历
export const sendjl = (data) => {
    return request({
        url: '/api/Job/add_resume',
        method: 'post',
        data:data
    })
}

// 我投递的简历
export const getmyjl = (data) => {
    return request({
        url: '/api/User/resume_list',
        method: 'post',
        data:data
    })
}

// 短信首页
export const messageindex = (data) => {
    return request({
        url: '/api/Shop/sms_index',
        method: 'post',
        data:data
    })
}

// 设置短信通知
export const setmessagenotice = (data) => {
    return request({
        url: '/api/Shop/sms_notice_config',
        method: 'post',
        data:{'register_status':data}
    })
}

// 短信发送记录
export const messagesendrecord = (data) => {
    return request({
        url: '/api/Shop/sms_send_list',
        method: 'post',
        data:data
    })
}

// 短信充值
export const shortincharge = (data) => {
    return request({
        url: '/api/Shop/sms_recharge',
        method: 'post',
        data:{"combo_id":data}
    })
}

// 短信充值记录
export const micreord = (data) => {
    return request({
        url: '/api/Shop/sms_recharge_list',
        method: 'post',
        data:data
    })
}

// 新闻列表
export const newsList = (data) => {
    return request({
        url: '/api/Index/news_list?page='+data+'&size=50',
        method: 'get',
    })
}

// 新闻详情
export const newsDetail = (data) => {
    return request({
        url: '/api/Index/news_detail?id='+data,
        method: 'get',
    })
}

// 精品推荐
export const recommands = (data) => {
    return request({
        url: '/api/Index/recom',
        method: 'post',
        data:data
    })
}

// ai帮写职位描述
export const AIzww = (data) => {
    return request({
        url: '/api/Shop/job_ai',
        method: 'post',
        data:{'name':data}
    })
}

// 手机号注册
export const registers = (data) => {
    return request({
        url: '/api/Login/tel_login',
        method: 'post',
        data:data
    })
}

// 手机号+密码登录
export const smlogin = (data) => {
    return request({
        url: '/api/Login/telPwd_login',
        method: 'post',
        data:data
    })
}

// 手机号+验证码登录
export const sylogin = (data) => {
    return request({
        url: '/api/Login/telCode_login',
        method: 'post',
        data:data
    })
}

// 忘记密码
export const resetpwd = (data) => {
    return request({
        url: '/api/Login/forget_pwd',
        method: 'post',
        data:data
    })
}

// 商家用户信息
export const shoUserInfo = (data) => {
    return request({
        url: '/api/Shop',
        method: 'post',
        data:data
    })
}

// 商家用户信息
export const shoUserAccount = (data) => {
    return request({
        url: '/api/Shop/account_info',
        method: 'post',
        data:data
    })
}

// 商家注销账号
export const shopdelAccount = (data) => {
    return request({
        url: '/api/Shop/del_user',
        method: 'post',
        data:data
    })
}

// 商家端订单详情
export const aorderdetail = (data) => {
    return request({
        url: '/api/Shop/activity_orderDetail',
        method: 'post',
        data:{"order_id":data}
    })
}

// 退款
export const refundmoney = (data) => {
    return request({
        url: '/api/Shop/activity_orderRefund',
        method: 'post',
        data:{"order_id":data}
    })
}

// 账户金额
export const accountInfo = (data) => {
    return request({
        url: '/api/Shop/account_list',
        method: 'post',
        data:data
    })
}

// 提现记录 
export const txrecord = (data) => {
    return request({
        url: '/api/Shop/apply_tx_list',
        method: 'post',
        data:data
    })
}

// 申请提现
export const applytx = (data) => {
    return request({
        url: '/api/Shop/apply_tx',
        method: 'post',
        data:data
    })
}


// 提交短信模板
export const submodule = (data) => {
    return request({
        url: '/api/Shop/send_sms',
        method: 'post',
        data:data
    })
}

// 取消短信充值
export const cancleRecharge = (data) => {
    return request({
        url: '/api/Shop/sms_cancel',
        method: 'post',
        data:data
    })
}

// 取消短信充值
export const repayRecharge = (data) => {
    return request({
        url: '/api/Shop/pay_again',
        method: 'post',
        data:data
    })
}

// 商家认证回显 
export const verback = () => {
    return request({
        url: '/api/Shop/shop_apply_info',
        method: 'post'
    })
}

// 获取活动二维码 
export const getaccode = (data) => {
    return request({
        url: '/api/Activity/qrcode?id='+data,
        method: 'get'
    })
}